import { render } from "./funder-documents.vue?vue&type=template&id=f14d4e1e&scoped=true"
import script from "./funder-documents.vue?vue&type=script&lang=js"
export * from "./funder-documents.vue?vue&type=script&lang=js"

import "./funder-documents.vue?vue&type=style&index=0&id=f14d4e1e&scoped=true&lang=scss"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f14d4e1e"]])

export default __exports__